// extracted by mini-css-extract-plugin
export default {"viewBtn":"PrintLink_viewBtn__SabVZ","spin":"PrintLink_spin__Mvvok"};